import {GET_TASKLIST, CLAIM_TASK, UNCLAIM_TASK, GET_TASK, COMPLETE_TASK} from '../action/taskAction';

const initialState = {
    taskList: [],
    loading: true,
};

const taskReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TASK:
            console.log(GET_TASK)
            return {
                ...state,
                task: action.payload,
                loading: false,
            };
        case GET_TASKLIST:
            console.log('GET_TASKLIST', action.payload);
            return {
                ...state,
                taskList: action.payload.tasks || [],
                pagination: action.payload.pagination || {},
                loading: false,
            };
        case CLAIM_TASK:
            return {
                ...state,
                taskList: state.taskList.map(task =>
                    task.taskId === action.payload.taskId ? { ...task, assignee: action.payload.userId } : task
                ),
            };
        case UNCLAIM_TASK:
            return {
                ...state,
                taskList: state.taskList.map(task =>
                    task.taskId === action.payload.taskId ? { ...task, assignee: null } : task
                ),
            };
        case COMPLETE_TASK:
            return {
                ...state,
                taskList: state.taskList.map(task =>
                    task.taskId === action.payload.taskId ? { ...task, completed: true } : task
                ),
            };
        default:
            return state;
    }
};

export default taskReducer;
